import MultiCarousel from "./multiCarousel";

export default MultiCarousel;
